"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.registers",
    path: "registers",
    component: "Registers"
});
let Registers = class Registers extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    onRegisterSaved(...args) {
        const data = args[0];
        const idx = _.findIndex(this.items, { id: data.id });
        if (idx == -1) {
            this.items.push(data);
        }
        else {
            this.items[idx] = data;
        }
        this.selectedRegister = data;
        this.createRegister = false;
    }
    onRegisterDeleted(...args) {
        const data = args[0];
        _.remove(this.items, { id: data.id });
        if (this.previousSelectionId) {
            const match = _.find(this.items, { id: this.previousSelectionId });
            if (match) {
                this.selectedRegister = match;
            }
        }
        if (this.items.length) {
            this.selectedRegister = this.items[0];
        }
        else {
            this.selectedRegister = null;
        }
        this.previousSelectionId = null;
        this.createRegister = false;
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_register');
    }
    selectedRegister;
    async $$load_selectedRegister() {
        return this.items.length ? this.items[0] : null;
    }
    previousSelectionId;
    createRegister;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['items', 'selectedRegister', 'previousSelectionId', 'createRegister', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                selectedRegister: null,
                previousSelectionId: null,
                createRegister: false,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Registers|Title", "Configure registers"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5190_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_3054425420812800_script_5194_getActionArgs_value($event) {
        (this.createRegister = true,
            this.previousSelectionId = this.selectedRegister?.id,
            this.selectedRegister = null);
    }
    async act_3054425420812800_script_5194_getActionArgs($event) {
        return {
            value: () => this.act_3054425420812800_script_5194_getActionArgs_value($event),
        };
    }
    async evh_3054425420812800_clickPreventStop(event, scope) {
        return await this.actions.evh_3054425420812800_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_814138253067422_script_5196_getActionArgs_value($event) {
        (this.createRegister = true,
            this.previousSelectionId = this.selectedRegister?.id,
            this.selectedRegister = null);
    }
    async act_814138253067422_script_5196_getActionArgs($event) {
        return {
            value: () => this.act_814138253067422_script_5196_getActionArgs_value($event),
        };
    }
    async evh_814138253067422_clickPreventStop(event, scope) {
        return await this.actions.evh_814138253067422_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3774018224472797_script_5198_getActionArgs_value($event) {
        this.onRegisterSaved($event.data);
    }
    async act_3774018224472797_script_5198_getActionArgs($event) {
        return {
            value: () => this.act_3774018224472797_script_5198_getActionArgs_value($event),
        };
    }
    async evh_3774018224472797_saved(event, scope) {
        return await this.actions.evh_3774018224472797_saved.executeFromDOM(this, event, scope);
    }
    async act_3774018224472797_script_5200_getActionArgs_value($event) {
        this.onRegisterDeleted($event.data);
    }
    async act_3774018224472797_script_5200_getActionArgs($event) {
        return {
            value: () => this.act_3774018224472797_script_5200_getActionArgs_value($event),
        };
    }
    async evh_3774018224472797_deleted(event, scope) {
        return await this.actions.evh_3774018224472797_deleted.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5190 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5190_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5189 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5190,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5189],
        });
        const act_2248226175642056_closeModal_5192 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_5191 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_5192,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5191],
        });
        const act_3054425420812800_script_5194 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3054425420812800_script_5194_getActionArgs,
            displayName: "addRegister",
            events: [],
        });
        const evh_3054425420812800_clickPreventStop_5193 = new core_1.actions.EventHandlerImpl({
            action: act_3054425420812800_script_5194,
            event: "click.prevent.stop",
            displayName: "addRegister",
        });
        const evh_3054425420812800_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3054425420812800_clickPreventStop_5193],
        });
        const act_814138253067422_script_5196 = new core_1.actions.ScriptAction({
            actionArgs: this.act_814138253067422_script_5196_getActionArgs,
            displayName: "addRegister",
            events: [],
        });
        const evh_814138253067422_clickPreventStop_5195 = new core_1.actions.EventHandlerImpl({
            action: act_814138253067422_script_5196,
            event: "click.prevent.stop",
            displayName: "addRegister",
        });
        const evh_814138253067422_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_814138253067422_clickPreventStop_5195],
        });
        const act_3774018224472797_script_5198 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3774018224472797_script_5198_getActionArgs,
            events: [],
        });
        const evh_3774018224472797_saved_5197 = new core_1.actions.EventHandlerImpl({
            action: act_3774018224472797_script_5198,
            event: "saved",
            displayName: "script",
        });
        const evh_3774018224472797_saved = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3774018224472797_saved_5197],
        });
        const act_3774018224472797_script_5200 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3774018224472797_script_5200_getActionArgs,
            events: [],
        });
        const evh_3774018224472797_deleted_5199 = new core_1.actions.EventHandlerImpl({
            action: act_3774018224472797_script_5200,
            event: "deleted",
            displayName: "script",
        });
        const evh_3774018224472797_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3774018224472797_deleted_5199],
        });
        const act_1548630417156826_closeModal_5202 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_5201 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_5202,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_5201],
        });
        return {
            act_7315092382398562_closeModal_5190,
            evh_7315092382398562_close_5189,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_5192,
            evh_2248226175642056_close_5191,
            evh_2248226175642056_close,
            act_3054425420812800_script_5194,
            evh_3054425420812800_clickPreventStop_5193,
            evh_3054425420812800_clickPreventStop,
            act_814138253067422_script_5196,
            evh_814138253067422_clickPreventStop_5195,
            evh_814138253067422_clickPreventStop,
            act_3774018224472797_script_5198,
            evh_3774018224472797_saved_5197,
            evh_3774018224472797_saved,
            act_3774018224472797_script_5200,
            evh_3774018224472797_deleted_5199,
            evh_3774018224472797_deleted,
            act_1548630417156826_closeModal_5202,
            evh_1548630417156826_clickPreventStop_5201,
            evh_1548630417156826_clickPreventStop,
            addRegister: act_814138253067422_script_5196,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], Registers.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Registers.prototype, "onSize", null);
Registers = __decorate([
    (0, vue_property_decorator_1.Component)()
], Registers);
exports.default = Registers;
vue_property_decorator_1.Vue.component("Registers", Registers);
